<template>
	<div>
		<draggable tag="div" v-model="mValue" handle=".handle" class="columns-wrapper px-1" :style="itemsStyle">
			<div v-for="(item, key) in mValue" :key="item.id" class="column-item pa-2">
				<v-hover v-slot:default="{ hover }">
					<v-card>
						<v-card-text>
							<slot v-bind="{ item, key }" />
						</v-card-text>
						<v-btn class="handle" v-if="hover" dark color="gray" small fab absolute top left>
							<v-icon small>fas fa-arrows-alt</v-icon>
						</v-btn>
						<v-btn @click="$emit('delete-item', key)" v-if="hover" fab small absolute top right color="red">
							<v-icon small>fas fa-trash</v-icon>
						</v-btn>
					</v-card>
				</v-hover>
			</div>
		</draggable>

		<v-col cols="12">
			<v-btn large color="primary" @click="$emit('add-item')">Add {{ itemsLabel }}</v-btn>
		</v-col>
	</div>
</template>

<script>
import draggable from "vuedraggable";

export default {
	components: {
        draggable,
    },
    props: {
		value: { type: Array, default: () => [] },
		itemsLabel: { type: String, default: 'Item' },
		itemsStyle: { type: Object },
	},
    computed: {
		mValue: {
			get () { return this.value },
			set (val) { this.$emit('input', val) },
		},
    },
}
</script>
